import { DataSource, HorizontalSpacer, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierInsServerPanel extends Layout {
    horizontalspacer1: HorizontalSpacer;
    panelServerInfo: Panel;
    sourceCarrierInsControl: DataSource;
    switchIsActive: Switch;
    switchSendCarriers: Switch;
    switchSetCarrierStatus: Switch;
    switchShowWatchDogReportStatus: Switch;
    switchUseDelta: Switch;
    textboxAccountId: Textbox;
    textboxAccountPassword: Textbox;
    textboxCarrierWatchAccountType: Textbox;
    textboxErrorEmail: Textbox;
    textboxLastSyncDate: Textbox;
    textboxSaferwatchLastUpdate: Textbox;
    textboxSaferwatchServiceKey: Textbox;
    textboxServer: Textbox;
}
